import { AlternateEmailOutlined, LocalPhoneOutlined } from '@mui/icons-material';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import { Alert, Box, Divider, Grid, Stack, Typography } from '@mui/material';
import React from 'react';

import { CustomAccordion } from '../../../components/CustomAccordion';
import { type Veranstaltung } from '../../../dtos';

type VeranstaltungsKontaktpersonProps = {
  readonly veranstaltung: Veranstaltung;
};

export const VeranstaltungsKontaktpersonComponent = ({ veranstaltung }: VeranstaltungsKontaktpersonProps) => (
  <CustomAccordion title="Kontaktpersonen" open={false} icon={ContactPhoneIcon}>
    {veranstaltung.kontaktperson.length === 0 && <Alert severity="info">Keine Kontaktpersonen vorhanden</Alert>}
    <Stack spacing={2}>
      {veranstaltung.kontaktperson.map((kontakt, i) => (
        <React.Fragment key={`${veranstaltung.id}${kontakt.kontaktpersonKuerzel}${kontakt.kontaktperson.objid}`}>
          <Box>
            <Typography variant="headingXxs">{kontakt.kontaktpersonTyp}</Typography>
            <p style={{ margin: 0 }}>
              {kontakt.kontaktperson.vorname} {kontakt.kontaktperson.nachname}
            </p>
            <p style={{ marginBottom: 0 }}>
              <AlternateEmailOutlined fontSize="small" />{' '}
              <span style={{ verticalAlign: 'super' }}>
                <a href={`mailto:${kontakt.kontaktperson.email}`}>{kontakt.kontaktperson.email}</a>
              </span>
            </p>
            <p style={{ marginTop: 0 }}>
              <LocalPhoneOutlined fontSize="small" />{' '}
              <span style={{ verticalAlign: 'super' }}>{kontakt.kontaktperson.tel ?? '-'}</span>
            </p>
            <Grid container spacing={1} rowSpacing={-5}>
              <Grid size={5}>Objekt-ID:</Grid>
              <Grid size={7}>
                <b>{kontakt.kontaktperson.objid}</b>
              </Grid>
              <Grid size={5}>Kürzel:</Grid>
              <Grid size={7}>
                <b>{kontakt.kontaktpersonKuerzel}</b>
              </Grid>
              <Grid size={5}>Typ:</Grid>
              <Grid size={7}>
                <b>{kontakt.kontaktpersonTyp}</b>
              </Grid>
              <Grid size={5}>Funktion 1:</Grid>
              <Grid size={7}>
                <b>{kontakt.kontaktperson.funktion1 ?? '-'}</b>
              </Grid>
              <Grid size={5}>Funktion 2:</Grid>
              <Grid size={7}>
                <b>{kontakt.kontaktperson.funktion2 ?? '-'}</b>
              </Grid>
              <Grid size={5}>Funktion 3:</Grid>
              <Grid size={7}>
                <b>{kontakt.kontaktperson.funktion3 ?? '-'}</b>
              </Grid>
            </Grid>
          </Box>
          {i + 1 !== veranstaltung.kontaktperson.length && <Divider />}
        </React.Fragment>
      ))}
    </Stack>
  </CustomAccordion>
);
